import { styled } from '@mui/material/styles';
import { FormControlLabel } from '@mui/material';

const CustomRadio = styled(FormControlLabel)(({ checked }) => ({
  '&.MuiFormControlLabel-root': {
    minHeight: '66px',
    width: '100%',
    border: '1px solid #EBEBEB',
    borderRadius: '4px',
    margin: 0,
    marginBottom: 16,
    padding: '10px 5px',
    display: 'flex',
  },
  '&:hover': {
    border: '2px solid #5E70CC',
  },
  '&:focus': {
    border: '2px solid #5E70CC',
  },
  '& .MuiFormControlLabel-label': {
    fontWeight: 500,
    fontSize: '20px',
    color: '#1D1E24',
  },
}));
export default CustomRadio;
